import {PropertyBase} from "./PropertyBase";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import * as React from "react";
import {observer} from "mobx-react";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";

export class DropDownProperty extends PropertyBase{
    public label:string="Field Type";
    public options:{label:string,value:string}[]=[];


    public AddOption(label:string,value:string)
    {
        this.options.push({
            value:value,
            label:label
        });
        return this;
    }


    public SubRenderer(): React.ReactNode {
        return (
            <SearchableSelect Value={this.GetOptionValue(this.OptionsPropertyName)}  disabled={this.disabled} Label={this.label} onChange={e=>this.SetOptionValue(e,this.OptionsPropertyName)} >
                {this.options.map(x=>
                    <option key={x.value} value={x.value}>{x.label}</option>
                )}
            </SearchableSelect>
        )
    }

}